export function layout($, InView, lightGallery) {

	//----------------------------------------------------
	// WINDOW DIMENSIONS & DOCUMENT DIMENSION
	//----------------------------------------------------
	// Window dimensions

	window.windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
	window.windowHeight = window.innerHeight ? window.innerHeight : $(window).height();

	// Document dimension
	window.documentHeight = $(document).height();


	$(window).on('resize orientationchange', function(){

		// Window dimensions

		window.windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
		window.windowHeight = window.innerHeight ? window.innerHeight : $(window).height();

		// Document dimension
		window.documentHeight = $(document).height();

	});

	//----------------------------------------------------
	// BROWSER
	//----------------------------------------------------
	window.isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

	if (window.isSafari) {
		$('html').addClass('isSafari');
	}

	//----------------------------------------------------
	// APPEAR EFFECTS
	//----------------------------------------------------

	var $modules = document.querySelectorAll('.module');
	var quote = document.querySelectorAll('blockquote');
	var $modulesBlur = document.querySelectorAll('.module--cta');
	var $lastNews = document.querySelectorAll('.js--transition-1');
	var $lastNewsTitle = document.querySelectorAll('.module-related-header .news-title');
	var $lastNewsButton = document.querySelectorAll('.module-related-header .button-p-wrapper');

	$modules.forEach(function(el) {

			var inview = InView(el, function(isInView, data) {

			  if (isInView) {
					el.classList.add('inview');

			  } else {
					el.classList.remove('inview');
			  }
			});
	});

	quote.forEach(function (el) {

	  InView(el, function (isInView, data) {

			if (isInView) {
				el.classList.add('inview');

			} else {
				el.classList.remove('inview');
			}
		});
	});

	/*$modulesBlur.forEach(function(el) {

			InView(el, function(isInView, data) {
				var triggerOffset = document.documentElement.clientHeight / 2;


				var pixs = data.elementOffsetTopInViewHeight - triggerOffset;
				var pixs2 = data.elementOffsetTopInViewHeight - triggerOffset;
				pixs = pixs / 100;
				pixs2 = pixs2 / 50;

			  if (isInView) {
					pixs = data.elementOffsetTopInViewHeight - triggerOffset;
					pixs2 = data.elementOffsetTopInViewHeight - triggerOffset;
					pixs = pixs / 100;
					pixs2 = pixs2 / 50;
					if (data.elementOffsetTopInViewHeight < data.inViewHeight/2) {
			      //console.log('in view (top half)')
						pixs = 0;
						//pixs2 = 0;
			    } else {
			      //console.log('in view (bottom half)')
			    }
			  } else {
					pixs = data.elementOffsetTopInViewHeight - triggerOffset;
					pixs2 = data.elementOffsetTopInViewHeight - triggerOffset;
					pixs = pixs / 100;
					pixs2 = pixs2 / 50;
			    if (data.windowScrollTop - (data.elementOffsetTop - data.inViewHeight) > data.inViewHeight) {
			      //console.log('not in view (scroll up)')
			    } else {
			      //console.log('not in view (scroll down)')
			    }
				}
				if ($(el).closest('.specialbackground').length){
					$(window).width()
					pixs2 =  -pixs2 / 2;
					var pixs3 = pixs2 * 3;

				} else {
					pixs2 = pixs2 * 3;
					var pixs3 = -pixs2/2;
				}


				$(el).css({
					"-webkit-filter": "blur("+pixs+"px)",
					"filter": "blur("+pixs+"px)"
				});

				if (window.windowWidth >=767) {
					$(el).find('.cta__body').css({
						"transform" : "translate(0, "+(pixs2)+"px)"
					});
				} else {
					$(el).find('.cta__body').css({
						"transform": "translate(0, 0px )"
					});
				}

				if (window.windowWidth >= 767) {
				$(el).find('.cta__button').css({
					"transform": "translate(0, " + (pixs2)+"px)"
				});
				} else {
					$(el).find('.cta__button').css({
						"transform": "translate(0, 0px )"
					});
				}

				if (window.windowWidth >= 767) {
					$(el).find('.cta__header').css({
						"transform": "translate(0, " + (pixs3) + "px)"
					});
				} else {
					$(el).find('.cta__header').css({
						"transform": "translate(0, 0px )"
					});
				}


			});
	});*/

	// Last news

	/*$lastNews.forEach(function (el) {
    var pixs = 0;
    var pixs2 = 0;

    var $lastNewsItem = el.querySelectorAll('.js--transition-1-item');

		InView(el, function (isInView, data) {
			var triggerOffset = document.documentElement.clientHeight / 2;


			pixs = (data.elementOffsetTopInViewHeight - triggerOffset) / 100;
			pixs2 = (data.elementOffsetTopInViewHeight - triggerOffset) / 50;

			if (isInView) {
				pixs = data.elementOffsetTopInViewHeight - triggerOffset;
				pixs2 = data.elementOffsetTopInViewHeight - triggerOffset;
				pixs = pixs / 100;
				pixs2 = pixs2 / 50;
				if (data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
					//console.log('in view (top half)')
					pixs = 0;
					//pixs2 = 0;
				} else {
					//console.log('in view (bottom half)')
				}
			} else {
				pixs = data.elementOffsetTopInViewHeight - triggerOffset;
				pixs2 = data.elementOffsetTopInViewHeight - triggerOffset;
				pixs = pixs / 100;
				pixs2 = pixs2 / 50;
				if (data.windowScrollTop - (data.elementOffsetTop - data.inViewHeight) > data.inViewHeight) {
					//console.log('not in view (scroll up)')
				} else {
					//console.log('not in view (scroll down)')
				}
			}
			if ($(el).closest('.specialbackground').length) {
				pixs2 = pixs2 * 2;
				var pixs3 = -pixs2 / 100;
				var pixs4 = pixs2 - 20;

			} else {
				pixs2 = pixs2 * 3; //Former 3
				var pixs3 = -pixs2 + 20;
				var pixs4 = (pixs2 - 20) + 80;
				var pixs5 = (pixs2 -60) ;
				var pixs6 = -pixs2 ;
			}


			$(el).css({
				"-webkit-filter": "blur(" + pixs + "px)",
				"filter": "blur(" + pixs + "px)"
			});

      let translateTitle = (window.windowWidth >= 767) ? pixs5 : 0;
      let translateButton = (window.windowWidth >= 767) ? pixs6 : 0;
      $($lastNewsTitle).css({
        "transform": "translate(0, " + (translateTitle) + "px)"
      });
      $($lastNewsButton).css({
        "transform": "translate(0, " + (translateButton) + "px)"
      });

			if (window.windowWidth >= 767) {

				$($lastNewsItem).each(function(i,e) {

          let translate = (i % 2 === 0) ? pixs3 : pixs4;

          $(e).css({
  					"transform": "translate(0, " + (translate) + "px)"
  				});

        });
			} else {
				$($lastNewsItem).css({
					"transform": "translate(0, 0px )"
				});
			}
		});
	});
	*/

	//----------------------------------------------------
	// Custom cursor
	//----------------------------------------------------

	function hoverLinks() {
		$('a, button').mouseenter(function() {
			$('body').addClass('hover');
		}).mouseleave( function() {
			$('body').removeClass('hover');
		});
	}

	var isTouch = ('ontouchstart' in window);

	if (!isTouch) {
		$('body').addClass('no-touch');

		// set the starting position of the cursor outside of the screen
		let clientX = -50;
		let clientY = -50;
		const innerCursor = document.querySelector('.cursor');

		const initCursor = () => {
			// add listener to track the current mouse position
			document.addEventListener('mousemove', e => {
				clientX = e.clientX;
				clientY = e.clientY;

				innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;

				document.documentElement.style.setProperty("--mx", clientX + "px");
				document.documentElement.style.setProperty("--my", clientY + "px");

			});

			// transform the innerCursor to the current mouse position
			// use requestAnimationFrame() for smooth performance
			/*const render = () => {
			
				requestAnimationFrame(render);
			};
			requestAnimationFrame(render);*/
		};

		initCursor();

	 hoverLinks();

	}

	//----------------------------------------------------
	// GO TO ANCHOR
	//----------------------------------------------------

	$('.js--gotoanchor').click(function(e) {
		e.preventDefault();
		var targetHash = $(this).attr('href');
		if (targetHash != '') {

			if ((window.windowWidth < 500)) {
				var scrollTop = $(targetHash).offset().top - 80;
			}
			else {
				var scrollTop = $(targetHash).offset().top - 100;
			}
			$('html, body').animate({ scrollTop:  scrollTop}, 1000);
		}
	});

  //----------------------------------------------------
  // Go back
  //----------------------------------------------------

  $('a:not(.js--goback)').click(function(e) {
    window.sessionStorage.setItem('samepage', 'same');
  });
  $('.js--goback').click(function(e) {
    let inside = window.sessionStorage.getItem('samepage') === 'same';
    if (inside) {
      e.preventDefault();
      window.history.back();
    }
  });

	//----------------------------------------------------
	// Lang Button
	//----------------------------------------------------


	function hideLang(elm) {
		const langElms = elm.find('li');
		if (langElms.length < 2) {
			elm.addClass('hidde-lang');
		} else {
			elm.removeClass('hidde-lang');
		}
	}

	const headerLang = $('.site-header').find('.site-header__lang');
	const modalLang = $('.menu-modal').find('.site-header__lang');

	hideLang($(headerLang));
	hideLang($(modalLang));
	hideLang($('.site-footer__lang'));

	$('.wpml-ls-current-language').click(function (e) {
		e.preventDefault();
			$(this)
				.closest('.site-header__lang')
					.toggleClass('open-lang');

	});

	$('.wpml-ls-current-language').click(function (e) {
		e.preventDefault();
		$(this)
			.closest('.site-footer__lang')
			.toggleClass('open-lang');

	});


	$('.wpml-ls-display').empty();
	$('.wpml-ls-native').each(function (index) {
		const langText = $(this).text();
		let firstTwoW = langText.substr(0, 2);
		$(this).text(firstTwoW);

	});

	// Lightbox

	$('.gallery').lightGallery({
		thumbnail: true,
		selector: 'a'
	});


	// Iframe responsive

	$('.wysiwyg iframe, .wysiwyg embed').each(function(i,e) {
		var key1 = /spotify/;
		var key2 = /instagram/;
		var origin = $(e).attr('src');
		var match1 = origin.search(key1);
		var match2 = origin.search(key2);
		if(match1 === -1 && match2 === -1) {
			$(e).wrapAll('<div class="embed-container embed-container-video"></div>');
		} else if (match1 !== -1 && match2 === -1){
			$(e).wrapAll('<div class="embed-container embed-container-spotify"></div>');
		} else if (match1 === -1 && match2 !== -1){
			$(e).wrapAll('<div class="embed-container embed-container-instagram"></div>');
		}
	
	});

}
